<template>
  <identify-confirm top-page-id="mb038"
                    previous-page-id="mb035"
                    next-page-id="mb037">
    <template slot="wizard">
      <main-wizard :active-index="2" type="useridentity"></main-wizard>
    </template>
  </identify-confirm>
</template>

<script>

import MainWizard from '../components/wizard/MainWizard'
import IdentifyConfirm from '../components/fileupload/IdentifyConfirm'

export default {
  name: 'Mb-036',
  metaInfo: {
    title: 'ご本人さま確認書類のご提出',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,本人確認書類'}
    ]
  },
  components: {
    IdentifyConfirm,
    MainWizard
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Mb036.vue